import bgDefault from '../images/home-bg-default.jpg'
import bgBrown from '../images/home-bg-brown.jpg'
import bgGreen from '../images/home-bg-green.jpg'
export const theme = {
  transition: {
    default: "all .5s ease",
    slowTransition: "all .8s linear",
  },
  themes: [
    {
      mainColor: "#1B1B1B",
      id: 0,
      name: "default",
      active: false,
    },
    {
      mainColor: "#564A40",
      id: 1,
      name: "brown",
      active: false,
    },
    {
      mainColor: "#1F2829",
      id: 2,
      name: "green",
      active: false,
    },
  ],
  colors: {
    solidDark: "#000",
    textPrimary: "#FFFFFF",
    primaryColor: "#1B1B1B",
    defaultGrey: "#4F4F4F",
    overlayColor: "rgba(0, 0, 0, .65)",
    defaultOverlay: "rgba(0, 0, 0, .65)",
  },
  images: {
    homeBg: bgDefault,
  },
  fontSize: {
    normal: "14px",
    medium: "16px",
  },
  fontWeight: {
    thin: 300,
    medium: 600,
    bold: 800,
  },
};

export const browntheme = {
  ...theme,
  colors: {
    ...theme.colors,
    primaryColor: "#564A40",
    defaultGrey: "#9FA3A1",
    overlayColor: "rgba(70, 70, 60, 0.75)",
    defaultOverlay: "rgba(0, 0, 0, .65)",
  },
  images: {
    homeBg: bgBrown,
  },
};

export const greentheme = {
  ...theme,
  colors: {
    ...theme.colors,
    primaryColor: "#1F2829",
    defaultGrey: "#919794",
    overlayColor: "rgba(31, 50, 41, 0.65)",
    defaultOverlay: "rgba(0, 0, 0, .65)",
  },
  images: {
    homeBg: bgGreen,
  },
};
